import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { type DocumentVersionSummary } from "~/api/types";
import { Card } from "~/atoms/card";
import { formatDate } from "~/helpers/date";
import { PublishReportProgress } from "./PublishReportProgress";

interface Props {
  data: DocumentVersionSummary;
}

const PublishReportCard = ({ data }: Props) => {
  const { t } = useTranslation();
  const publishedAt = formatDate(data.publishedAt);

  return (
    <Card className="h-fit w-48 shrink-0 gap-2 p-2">
      <div className="h-14">
        <Link
          to={`/documents/${data.document.id}?versionId=${data.id}&tab=anchoring`}
        >
          <div className="hover:text-primary line-clamp-2" title={data.title}>
            {data.title}
          </div>
        </Link>
        <div className="text-muted-foreground truncate text-xs">
          {data.document.category.title}
        </div>
      </div>
      <PublishReportProgress
        documentVersionId={data.id}
        totalCount={data.readers.totalCount}
        openedCount={data.readers.openedCount}
        readCount={data.readers.readCount}
        canSeeDetails
      />
      <div className="text-muted-foreground text-sm">
        {t(($) => $.commons.documentStatus.published)} {publishedAt}
      </div>
    </Card>
  );
};

export default PublishReportCard;
